// src/utils/qbccCompliance.ts
// Phase 2 — G12 / R19

const MCB_DISCLOSURE_THRESHOLD = 150_000
export const RETENTION_TRUST_THRESHOLD = 1_000_000
export const BCIPA_PAYMENT_DAYS = 25
export const QBCC_LICENCE_THRESHOLD = 3_300

export function requiresQBCCDisclosure(contractValue: number): boolean {
  return contractValue >= MCB_DISCLOSURE_THRESHOLD
}
export function requiresRetentionTrust(projectValue: number): boolean {
  return projectValue >= RETENTION_TRUST_THRESHOLD
}
export function requiresQBCCLicence(contractValue: number): boolean {
  return contractValue >= QBCC_LICENCE_THRESHOLD
}

export interface SubcontractComplianceCheck {
  disclosureRequired: boolean; licenceRequired: boolean
  retentionTrustRequired: boolean; whsGateBlocking: boolean; summary: string[]
}

export function checkSubcontractCompliance(
  contractValue: number, projectValue: number,
  hasQBCCLicence: boolean, whsPrequalStatus: string,
): SubcontractComplianceCheck {
  const disclosureRequired = requiresQBCCDisclosure(contractValue)
  const licenceRequired = requiresQBCCLicence(contractValue)
  const retentionTrustRequired = requiresRetentionTrust(projectValue)
  const whsGateBlocking = whsPrequalStatus === 'PENDING' || whsPrequalStatus === 'EXPIRED'
  const summary: string[] = []
  if (disclosureRequired) summary.push(`QBCC subcontract disclosure required — value exceeds $${MCB_DISCLOSURE_THRESHOLD.toLocaleString()} threshold (QBCC Act s.67AA)`)
  if (licenceRequired && !hasQBCCLicence) summary.push('QBCC licence required before award — subcontract value exceeds $3,300 threshold')
  if (retentionTrustRequired) summary.push(`Retention trust account required — project value exceeds $${(RETENTION_TRUST_THRESHOLD / 1_000_000).toFixed(0)}M (Building Industry Fairness Act 2017)`)
  if (whsGateBlocking) summary.push(`WHS prequalification ${whsPrequalStatus.toLowerCase()} — award blocked until WHS file is approved`)
  return { disclosureRequired, licenceRequired, retentionTrustRequired, whsGateBlocking, summary }
}
